import * as types from "../types/unRegisterRider.types";
import { getListingService, getSingleService } from '../../services/unRegisterRider.service';
import { validationErrors } from "../../utils/Helpers";


export const listAction = (data) => {
  return async (dispatch, getState)  => {
    try {
      dispatch({
        type: types.SET_UN_REGISTER_RIDER_LOADING,
        payload: true,
      });
      await getListingService(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        // console.log(res.data)
        if(res.data.code === 200){
          dispatch({
            type: types.SET_UN_REGISTER_RIDER_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_UN_REGISTER_RIDER_PAGINATION,
            payload: res.data.pagination,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({
        type: types.SET_UN_REGISTER_RIDER_LOADING,
        payload: false,
      });
    }
  };
}

export const filterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_UN_REGISTER_RIDER_FILTER,
      payload: data,
    });
  };
};


// Get Single
export const singleAction = (data) => {
  return async (dispatch, getState)  => {
    try {
      dispatch({
        type: types.SET_UN_REGISTER_RIDER_LOADING,
        payload: true,
      });
      await getSingleService(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        // console.log(res.data)
        if(res.data.code === 200){
          dispatch({
            type: types.SET_UN_REGISTER_RIDER_DETAIL_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {validationErrors(e)} finally {
      dispatch({
        type: types.SET_UN_REGISTER_RIDER_LOADING,
        payload: false,
      });
    }
  };
}

// export const getSingleAction = (id) => {
//   return async (dispatch, getState) => {
//     try {
//       // console.log(id)

//       await getSingleService(getState().authReducer.token, getState().authReducer.user.id, id).then((res) => {
//         dispatch({type: types.SET_UN_REGISTER_RIDER_DETAIL_DATA, payload: res.data.data});
//       })
//     } catch (e) {validationErrors(e)}
//   };
// };